module.exports = __webpack_public_path__ + "media/images/banner/covid/zh-hant-30d226bd8dceb4b9e9f9117e7757ba32.jpg";